module.exports = __webpack_public_path__ + "img/load.baaec0da.svg";